import { useEffect, useState } from "react"
import { useApi } from "utils"

export type StockItem = {
  code: string
  description: string
  unit: string
} & Record<string, number>

type DataType = {
  locations: string[]
  payload: StockItem[]
}
export function useList({ start_date, end_date }: { start_date: string, end_date: string }) {

  const defaultValue: DataType = {
    locations: [],
    payload: [],
  }

  const api = useApi()
  const [data, setData] = useState<DataType>(defaultValue)
  const [isLoading, setLoading] = useState(true)

  const fetchData = async () => {

    setLoading(true)
    try {
      const res = await api.get("/sales_analyze_period/get_data_sales_analyse_comparation_locations_only", { params : { start_date, end_date } })
      setData(res.data)
    } catch {
      setData(defaultValue)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start_date, end_date])

  return {
    data,
    isLoading,
    refetch: fetchData,
  }
}


